var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeywords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5V6.5C4 5.3955 4.8955 4.5 6 4.5H14.085C14.351 4.5 14.606 4.6055 14.794 4.7935L19.2065 9.206C19.3945 9.394 19.5 9.649 19.5 9.915V17.5C19.5 18.6045 18.6045 19.5 17.5 19.5H6C4.8955 19.5 4 18.6045 4 17.5V10.5Z",
    stroke: "#85909F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5H8.51M14.5 14.5H14.51",
    stroke: "#85909F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywords);
export default __webpack_public_path__ + "static/media/keywords.42cd9ba2d9495d3b7523a081de14d754.svg";
export { ForwardRef as ReactComponent };